import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"4px","margin-left":"2px"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  class: "game_title",
  style: {"display":"inline-block","font-size":"1.3rem"}
}
const _hoisted_4 = {
  class: "badge-all",
  style: {"width":"100%","display":"flex","flex-direction":"column"}
}
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"center","align-items":"flex-start"} }
const _hoisted_7 = { class: "badge-image-wrapper rounded" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"flex-grow":"1"} }
const _hoisted_10 = { style: {"min-height":"3rem","text-align":"left","padding-left":"8px"} }
const _hoisted_11 = { style: {"text-align":"right"} }
const _hoisted_12 = { style: {"display":"inline-flex","justify-content":"right","align-items":"center"} }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { style: {"padding":"0 0 0 4px","line-height":"1rem"} }
const _hoisted_15 = { style: {"text-align":"right"} }
const _hoisted_16 = {
  key: 0,
  style: {"display":"inline-flex","justify-content":"flex-end"}
}
const _hoisted_17 = {
  key: 0,
  style: {"font-size":"small","color":"#666","word-break":"break-all","text-align":"right","line-height":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserBlockSmall = _resolveComponent("UserBlockSmall")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badgeProjectList, (badgeProject) => {
    return (_openBlock(), _createElementBlock("div", {
      key: 'badgeProject' + badgeProject.id,
      style: {"padding-bottom":"1.5rem"}
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(badgeProject.badgeList, (badge) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'badge' + badge.id
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h4", _hoisted_3, _toDisplayString(badge.title), 1)
            ])
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "badge-image",
                    src: _ctx.urls.getBadgeImageURL(badgeProject, badge)
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(badge.explanation), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (badge.publicPage)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: _ctx.projectURL(badgeProject, badge),
                          class: "gray-focus"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(badge.publicPage?.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString("プロジェクトNo." + badgeProject.id), 1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_UserBlockSmall, {
                        dtoUser: badgeProject.user
                      }, null, 8, ["dtoUser"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.showDisplaySwitch)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", null, [
                          (_ctx.isPublicButtonDisabled(badge))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " ※非公開ページで取得されたバッジのため公開できません。 "))
                            : (_openBlock(), _createBlock(_component_Switch, {
                                key: 1,
                                textOn: '公開プロフィールに表示する',
                                textOff: '公開プロフィールに表示しない',
                                isOn: badge.isDisplay,
                                onInput: ($event: any) => (_ctx.onChange(badge))
                              }, null, 8, ["isOn", "onInput"]))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ]))
  }), 128))
}